import { Subscription, TimeoutError } from 'rxjs';

import { Directive, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { BetaGroupDialogComponent } from '../components/beta-group/beta-group.component';
import { EAlertTypes } from '../dialogs/alert/alert.component';
import { DialogService, IDialogHandle } from '../dialogs/dialog.service';
import { AccountService } from '../services/account.service';
import { ErrorHandlingService } from './error-handling.service';

@Directive({
  selector: '[errorHandling]',
})
export class ErrorHandlingDirective {
  // optional
  @Output() callback: EventEmitter<any> = new EventEmitter();
  @Input() shouldDisplayErrorInDialog = true;
  readonly baseUrl: string;
  private errorsSubscription: Subscription;
  private isDialogOpen = false;

  constructor(
    private translate: TranslateService,
    private dialogService: DialogService,
    private accountService: AccountService,
    private errorHandlingService: ErrorHandlingService
  ) {
    this.baseUrl = `${this.accountService.baseUrl}/error/`;

    this.errorsSubscription = this.errorHandlingService.errors.subscribe(
      (error) => {
        if (this.shouldDisplayErrorInDialog) {
          this.openErrorDisplayDialog(error);
        }
      }
    );
  }

  openErrorDisplayDialog(error: any) {
    if (!error) {
      return;
    }

    // unauthorized requests
    if (error.status === 401 || error.status === 403) {
      const redirectUrl = this.baseUrl + 'Unauthorized';
      window.location.href = redirectUrl;
    } else if (error.status === 402) {
      // registration needed
      const extraData = { accountName: error.json().accountName };
      this.dialogService.createDialog<BetaGroupDialogComponent>(
        BetaGroupDialogComponent,
        extraData
      );
    } else if (error.status === 507) {
      /** Already handled in FileUploaderClient. */
    } else if (error.status >= 500) {
      // application exception
      if (!this.isDialogOpen) {
        this.isDialogOpen = true;
        const dialogHandle: IDialogHandle = this.dialogService.alert({
          header: this.translate.instant(
            'COMMON.DIALOGS.ERROR_HANDLING.SERVER_ERROR.HEADER'
          ),
          message: this.translate.instant(
            'COMMON.DIALOGS.ERROR_HANDLING.SERVER_ERROR.MESSAGE'
          ),
          type: EAlertTypes.Alert,
          okCaption: this.translate.instant(
            'COMMON.DIALOGS.ERROR_HANDLING.SERVER_ERROR.OK'
          ),
        });

        dialogHandle.onClose.subscribe(() => (this.isDialogOpen = false));
      }
    } else if (error instanceof TimeoutError) {
      // connection timout exception

      if (!this.isDialogOpen) {
        this.isDialogOpen = true;
        const dialogHandle: IDialogHandle = this.dialogService.alert({
          header: this.translate.instant(
            'COMMON.DIALOGS.ERROR_HANDLING.CONNECTION_ERROR.HEADER'
          ),
          message: this.translate.instant(
            'COMMON.DIALOGS.ERROR_HANDLING.CONNECTION_ERROR.MESSAGE'
          ),
          type: EAlertTypes.Alert,
          okCaption: this.translate.instant(
            'COMMON.DIALOGS.ERROR_HANDLING.CONNECTION_ERROR.OK'
          ),
        });

        dialogHandle.onClose.subscribe(() => (this.isDialogOpen = false));
      }
    } else {
      if (!this.isDialogOpen) {
        this.isDialogOpen = true;
        const dialogHandle: IDialogHandle = this.dialogService.alert({
          header: this.translate.instant(
            'COMMON.DIALOGS.ERROR_HANDLING.UNKNOWN_ERROR.HEADER'
          ),
          message: this.translate.instant(
            'COMMON.DIALOGS.ERROR_HANDLING.UNKNOWN_ERROR.MESSAGE'
          ),
          type: EAlertTypes.Alert,
          okCaption: this.translate.instant(
            'COMMON.DIALOGS.ERROR_HANDLING.UNKNOWN_ERROR.OK'
          ),
        });

        dialogHandle.onClose.subscribe(() => (this.isDialogOpen = false));
      }
    }
  }
}
